import React from "react";
import { Route, Switch } from "react-router-dom";

import { Routing } from "../../../../core/routing";
import { ROUTES } from "../../../../routes";
import { BudgetCreatePage } from "./create_page";
import { BudgetDetailPage } from "./detail_page";
import { BudgetEditPage } from "./edit_page";
import { BudgetListPage } from "./list_page";

export const BudgetMainPage: React.FC = () => {
  return (
    <Switch>
      <Route path={ROUTES.budget} exact>
        <BudgetListPage />
      </Route>

      <Route path={Routing.generateCreateRoute(ROUTES.budget)}>
        <BudgetCreatePage />
      </Route>

      <Route path={Routing.generateEditRoute(ROUTES.budget)}>
        <BudgetEditPage />
      </Route>

      <Route path={Routing.generateDetailRoute(ROUTES.budget)}>
        <BudgetDetailPage />
      </Route>
    </Switch>
  );
};
